import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getValidationErrors } from './utils/getValidationErrors';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReviewWizardContext = /*#__PURE__*/createContext(undefined);
export function ReviewContextProvider({
  children,
  customValidationErrors = [],
  defaultReview = {
    content: {},
    ratings: {},
    tags: {}
  },
  onChange,
  validationSchema
}) {
  const [review, setReview] = useState(defaultReview);
  const [validationErrors, setValidationErrors] = useState([]);

  // validates inputs
  useEffect(() => {
    const newValidationErrors = [];
    Object.entries(validationSchema).forEach(([fieldType, validationSection]) => {
      Object.entries(validationSection).forEach(([fieldKey, validationObject]) => {
        const value = review[fieldType][fieldKey];
        getValidationErrors({
          fieldKey,
          fieldType: fieldType,
          validationObject: validationObject,
          value
        }).forEach(error => newValidationErrors.push(error));
      });
    });
    setValidationErrors(newValidationErrors);
  }, [review, validationSchema]);
  const getFieldValidation = useCallback((fieldType, fieldKey) => {
    if (validationSchema && validationSchema[fieldType] && validationSchema[fieldType][fieldKey]) {
      return validationSchema[fieldType][fieldKey];
    }
    return {};
  }, [validationSchema]);
  const onUpdateReview = useCallback(updates => {
    const updatedReview = Object.assign({}, review);
    Object.keys(updates).forEach(fieldType => {
      Object.entries(updates[fieldType]).forEach(([fieldKey, value]) => {
        updatedReview[fieldType][fieldKey] = value;
      });
    });
    if (onChange) {
      onChange(updatedReview);
    }
    setReview(updatedReview);
  }, [onChange, review]);
  return /*#__PURE__*/_jsx(ReviewWizardContext.Provider, {
    value: {
      customValidationErrors,
      getFieldValidation,
      onUpdateReview,
      review,
      validationErrors
    },
    children: children
  });
}
export function useReviewContext() {
  const context = useContext(ReviewWizardContext);
  if (!context) {
    throw new Error('useReviewContext must be used within a ReviewContextProvider');
  }
  return context;
}